import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setMode } from "../../redux/appReducer";

const ModeSwitcher = () => {
  const [dark, setDark] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage?.getItem("mode") === "dark") {
      document.documentElement.classList.add("dark");
      setDark(true);
      dispatch(setMode("dark"));
    } else {
      document.documentElement.classList.remove("dark");
      setDark(false);
      dispatch(setMode("light"));
    }
  }, []);

  const handleClick = () => {
    if (dark) document.documentElement.classList.remove("dark");
    if (!dark) document.documentElement.classList.add("dark");

    setDark(!dark);
    dispatch(setMode(!dark ? "dark" : "light"));
  };

  return (
    <button onClick={handleClick}>
      {!dark ? (
        <svg
          v-if="dark"
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
          />
        </svg>
      )}
    </button>
  );
};

export default ModeSwitcher;
